import { Fragment, useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router";
import { getSession, processInt, processNum, processStr, processStrWithSpace, truncateString, valdiatePage } from "../../global";
import { getCNs, GetAddressLabelLogo, generateAddressLabels, generateAddressLabelsStickers } from '../../services/addresslabelservice';
import { getSubAccountLocations } from '../../services/userservice';
import { useSelector, useDispatch } from "react-redux";
import { setLoading } from "../../redux/appSlice";
import { setData, reset, setLocations, setGrid, updateGrid as updateG, setType, updateGridObject, setTwoCnRow } from "../../redux/addressLabelSlice";
import './addresslabel.css';
import Pagination from '../../components/paginations';
import SeeMoreModal from "../../components/SeeMoreModal";

const AddressLabel = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [accountNo, setAccountNo] = useState('');

    const state = useSelector(state => {
        return { appData: state.appData, addressLabelData: state.addressLabelData }
    })
    
    const { userInfo, loading, subaccounts, services, codAmountLimit } = state.appData;

    const { data, locations, grid, type, isTwoCnRow } = state.addressLabelData;

    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [originalGrid, setOriginalGrid] = useState([]);
    
    const searchObjInit = {
        cn: '',
        consignee: '',
        refNo: '',
        bookingDate: '',
        deliveryDate: ''
    };


    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => setSearchObj(prev => { return { ...prev, [key]: val } });



    const gridKeys = [
        {
            key: '', 
            name: <input className="form-check-input" type="checkbox" checked={grid.length === grid.filter(y => y.selected).length} onChange={(e) => {
                const g = grid.map(y => {
                    return { ...y, selected: e.target.checked }
                });
                dispatch(setGrid({ data: g }));
            }} />, 
            searchBox: false, 
            visible: true
        },
        {key: '', name:
            <button type="button" className="btn btn-sm btn-primary" onClick={async () => {
                const d = grid.filter(c => c.selected);
                if (d.length > 0) {
                    await generateLabels(d, data.isCod);
                } else {
                    alert('Select Consignments');
                }
            }}>Combined Address Label</button>, searchBox: false, visible: true},
        {key: '', name: 'Edit', searchBox: false, visible: true},
        {key: 'cn', name: 'Consignment No', searchBox: true, visible: true},
        {key: 'consignee', name: 'Consignee', searchBox: true, visible: true},
        {key: 'pieces', name: 'Pieces', searchBox: false, visible: true},
        {key: 'weight', name: 'Weight', searchBox: false, visible: true},
        {key: 'refNo', name: 'Reference No', searchBox: true, visible: true},
        {key: 'bookingDate', name: 'Booking Date', searchBox: true, visible: true},
        {key: 'serviceType', name: 'Service Type', searchBox: false, visible: true},
        {key: 'codAmount', name: 'Cod Amount', searchBox: false, visible: true},
        {key: 'productDetails', name: 'Product Details', searchBox: false, visible: true},
        {key: 'remarks', name: 'Remarks', searchBox: false, visible: true},
        {key: 'timeSlot', name: 'Time Slot', searchBox: false, visible: accountNo == "281588"},
        {key: 'deliveryDate', name: 'Delivery Date', searchBox: true, visible: accountNo == "281588"},
        {key: 'deliveryType', name: 'Delivery Type', searchBox: false, visible: accountNo == "281588"},
    ]
    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });

    useEffect(() => {
        if (valdiatePage('/addresslabel')) {
            dispatch(setType({ data: userInfo.addressLabelType || 1 }));
        } else {
            history.push('/login');
        }
        return () => {
            dispatch(reset({}));
            dispatch(setGrid({ data: [] }));
        }
    }, []);

    const updateData = (key, val) => dispatch(setData({ data: { ...data, [key]: val } }));

    const onSearch = async () => {
        if (!data.locationId) {
            alert('Select Location');
            return;
        }

        if (!data.from) {
            alert('Select From Date');
            return;
        }

        if (!data.to) {
            alert('Select To Date');
            return;
        }

        const from = Date.parse(data.from);
        const to = Date.parse(data.to);

        if (from > to) {
            alert('Invalid Date');
            return;
        }

        dispatch(setLoading({ data: true }));
        const rs = await getCNs(data);
        dispatch(setLoading({ data: false }));
        if (rs.sts > 0) {
            alert(rs.msg);
            dispatch(setGrid({ data: [] }))
        } else {
            if (rs.data && rs.data.length > 0) {
                dispatch(setGrid({ data: rs.data }))
                setOriginalGrid(rs.data);
            } else {
                alert('No Data Found');
            }
        }
    }

    const updateGrid = (index, key, val) => {
        dispatch(updateG({ index, key, val }));
    }

    const fnGetLogo = async (labelData, type) => {
        let subAccountIdLogo2 = 0;
        let base64 = '';

        const arr = [];
        for (let e of labelData) {
                if(e.subAccountId && Number(subAccountIdLogo2) != Number(e.subAccountId)) {
                    const rs2 = await GetAddressLabelLogo({
                        "subAccountId": e.subAccountId
                    });
                    if(rs2.ok) {
                        base64 = rs2.logoBase64;
                    }
                    subAccountIdLogo2 = e.subAccountId;
                }
                arr.push({ ...e, logoBase64: e.subAccountId ?  base64 : ''  });
        }
        return arr;
      }

      const fnGetLogoWithoutShipper = async (labelData) => {
        const arr = [];
        for (let e of labelData) {
                arr.push({ ...e, shipperPhone: "N/A"  });
        }
        return arr;
      }

    const generateLabels = async (labelData, isCod) => {


        const mappedData = labelData;

        // if (mappedData.some(x => (!userInfo.isZeroCodAllowed && +x.codAmount <= 0) || +x.codAmount > 99999)) {
        //     alert("Invalid COD Amount found in Grid");
        //     return;
        // }


        const amountLimitCheck = codAmountLimit?.length > 0 && codAmountLimit?.filter(i => i.accountNo.toUpperCase() == accountNo.toUpperCase());
        let codAmountL = 99999;
        if(amountLimitCheck.length > 0) {
            codAmountL = amountLimitCheck[0].amount;
        }

        if (mappedData.some(x => (!userInfo.isZeroCodAllowed && +x.codAmount <= 0) || +x.codAmount > codAmountL)) {
            alert(`Cod Amount must be greater than 0 and less than ${codAmountL}`);
            return;
        }

        if (mappedData.some(x => !x.pieces || +x.pieces <= 0)) {
            alert("Invalid Pieces Amount found in Grid");
            return;
        }

        let maxAllowedWeight = data.isCod ? 99 : 9999;

        const codWeightLimits = getSession('codWeightLimit');

        const accountWeightLimit = codWeightLimits?.find(
            limit => limit.accountNo.toUpperCase() == accountNo.toUpperCase()
        );

        if (accountWeightLimit) {
            maxAllowedWeight = Math.max(maxAllowedWeight, accountWeightLimit.weight);
        }

        if ((isCod && mappedData.some(x => +x.weight <= 0 || +x.weight > maxAllowedWeight)) || (!isCod && mappedData.some(x => +x.weight <= 0 || +x.weight > maxAllowedWeight))) {
            alert("Invalid Weight found in Grid");
            return;
        }

        if (type) {
            const dt = {
                user: { id: userInfo.id },
                addressLabels: mappedData.map(x => {
                    return {
                        cn: x.cn,
                        consignee: x.consignee,
                        pieces: x.pieces,
                        weight: x.weight,
                        refNo: x.refNo,
                        serviceType: x.serviceType,
                        productDetails: x.productDetails,
                        remarks: x.remarks,
                        codAmount: x.codAmount,
                        addressLabelEdited: x.addressLabelEdited,
                        editMode: x.editMode,
                        locationName: x.locationName,
                        shipper: x.shipper
                    }
                })
            };

            dispatch(setLoading({ data: true }));
            const rs = await generateAddressLabels(dt);
            dispatch(setLoading({ data: false }));
            let message = rs.msg;

            alert(message);       

            if (rs.ok && rs.latestCN?.length > 0) {
                sessionStorage.setItem('type', type);
                sessionStorage.setItem('labeldata', JSON.stringify(data.isWithoutShipper ? await fnGetLogoWithoutShipper(rs.latestCN) : rs.latestCN));

                if (type == 5) {
                    sessionStorage.setItem('isTwoCnRow', isTwoCnRow);
                    window.open('/cplight/addresslabelSticker.html', '_blank');
                } else if (type == 6) {
                    window.open('/cplight/addresslabel4x6.html', '_blank');
                } else if (type == 4) {
                    window.open('/cplight/addresslabel15x10.html', '_blank');
                } else if (type == 3) {
                    window.open('/cplight/addresslabel.html', '_blank');
                } else {
                    window.open('/cplight/addresslabel2.html', '_blank');
                }

                // const g = [...grid].map(obj => {
                //     const found = updatedMappedData.find(s => s.cn === obj.cn)                    
                //     if(found) {
                //         return { ...obj, editMode: false, addressLabelEdited: true }
                //     } else {
                //         return { ...obj, editMode: false }
                //     }
                // });
                dispatch(setGrid({ data: []}));
            }
        }    
    }

    const onGenerateLabels = async (x) => {
        await generateLabels([x], data.isCod);
    }

    return userInfo && <section className="section">
        <div className="section-header">
            <h1>Address Label</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            <div className="row">
                <div className="col-lg-2">
                    <label style={{ whiteSpace: 'nowrap' }}>Without Shipper Contact</label><br />
                    <label className="switch">
                        <input type="checkbox" checked={data.isWithoutShipper} onChange={(e) => updateData('isWithoutShipper', e.target.checked)} />
                        <span className="slider round"></span>
                    </label>
                </div>
                <div className="col-lg-2">
                    <label>Sub Account</label>
                    <select className="form-select" value={data.subAccountId} onChange={async (e) => {
                        const val = e.target.value;
                        const d = { ...data, subAccountId: val, locationId: '' };
                        if (val) {
                            d.isCod = e.target[e.target.selectedIndex].getAttribute('data-iscod') === 'true';
                            const accno = e.target[e.target.selectedIndex].getAttribute('data-accno');
                            setAccountNo(accno);
                            const locs = await getSubAccountLocations(userInfo.id, val)
                            //const locs = await getLocations(userInfo.id, accno)
                            if (locs)
                                dispatch(setLocations({ data: locs }));
                        } else {
                            d.isCod = null;
                            dispatch(setLocations({ data: [] }));
                        }
                        dispatch(setData({ data: d }));
                    }}>
                        <option value="" data-iscod="" data-accno="">Select Sub Account</option>
                        {
                            subaccounts.map((x, index) => <option key={index} value={x.id} data-iscod={x.isCod} data-accno={x.accountNo}>{x.name}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg-2">
                    <label>Locations</label>
                    <select className="form-select" value={data.locationId} onChange={(e) => updateData('locationId', e.target.value)}>
                        <option value="">Select Location</option>
                        {
                            locations.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg-2">
                    <label>Order From</label>
                    <input type="datetime-local" className="form-control" value={data.from} onChange={(e) => updateData('from', e.target.value)} />
                </div>
                <div className="col-lg-2">
                    <label>Order To</label>
                    <input type="datetime-local" className="form-control" value={data.to} onChange={(e) => updateData('to', e.target.value)} />
                </div>
                <div className="col-sm-1">
                    <button type="button" className="btn btn-primary mt-4" onClick={onSearch} disabled={loading}>
                        Search
                    </button>
                </div>
            </div>
            {
                originalGrid.length > 0 &&
                <div className="row mt-3">
                    <div className="col">
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center' }}>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="type" id="type1" checked={type === 1} onChange={e => {
                                    if (e.target.checked) {
                                        dispatch(setType({ data: 1 }));
                                    }
                                }} />
                                <label className="form-check-label" htmlFor="type1">All Copies</label>
                            </div>
                            <div className="form-check" style={{ marginLeft: 10 }}>
                                <input className="form-check-input" type="radio" name="type" id="type2" checked={type === 2} onChange={e => {
                                    if (e.target.checked) {
                                        dispatch(setType({ data: 2 }));
                                    }
                                }} />
                                <label className="form-check-label" htmlFor="type2">Consignee Copy Only</label>
                            </div>
                            <div className="form-check" style={{ marginLeft: 10 }}>
                                <input className="form-check-input" type="radio" name="type" id="type3" checked={type === 3} onChange={e => {
                                    if (e.target.checked) {
                                        dispatch(setType({ data: 3 }));
                                    }
                                }} />
                                <label className="form-check-label" htmlFor="type3">2 CN on 1 Page</label>
                            </div>
                            <div className="form-check" style={{ marginLeft: 10 }}>
                                <input className="form-check-input" type="radio" name="type" id="type4" checked={type === 4} onChange={e => {
                                    if (e.target.checked) {
                                        dispatch(setType({ data: 4 }));
                                    }
                                }} />
                                <label className="form-check-label" htmlFor="type4">15x10 Sticker</label>
                            </div>
                            <div className="form-check" style={{ marginLeft: 10 }}>
                                <input className="form-check-input" type="radio" name="type" id="type5" checked={type === 5} onChange={e => {
                                    if (e.target.checked) {
                                        dispatch(setType({ data: 5 }));
                                    }
                                }} />
                                <label className="form-check-label" htmlFor="type5">2x4 Sticker</label>
                                {type === 5 && <div style={{ position: 'absolute' }}>
                                    <label className="switch">
                                        <input type="checkbox" checked={isTwoCnRow} onChange={(e) => dispatch(setTwoCnRow({ data: e.target.checked }))} />
                                        <span className="slider round"></span>
                                    </label>
                                    <label style={{ verticalAlign: '-5px', margin: '5px' }}>Two Columns</label><br />
                                </div>}
                            </div>
                            <div className="form-check" style={{ marginLeft: 10 }}>
                                <input className="form-check-input" type="radio" name="type" id="type6" checked={type === 6} onChange={e => {
                                    if (e.target.checked) {
                                        dispatch(setType({ data: 6 }));
                                    }
                                }} />
                                <label className="form-check-label" htmlFor="type6">4x6 Sticker</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-12" style={{ marginTop: '32px' }}>

                    {
                originalGrid.length > 0 &&
                            <Pagination
                                setGrid={(result) => {
                                    dispatch(setGrid({data: result}));
                                }}                                
                                searchObjInit={searchObjInit}
                                searchObject={searchObject}
                                originalGrid={originalGrid}
                                setPage={setPage}
                                setPageLimit={setPageLimit}
                                requestSort={requestSort}
                                sortConfig={sortConfig}
                                updateSearchData={updateSearchData}
                                sortedArray={sortedArray}
                                data={data}
                                dataCount={grid.length}
                                pageLimit={pageLimit}  
                                gridKeys={gridKeys}
                                page={page}
                                grid={
                                sortedArray && sortedArray.length > 0 && sortedArray.map((x, index) =>
                                            <Fragment key={index}>
                                                <tr>
                                        <td>{(index + 1)+(page*pageLimit)}</td>
                                                    <td style={{ position: 'relative' }}>
                                                <input className="form-check-input" checked={x.selected} type="checkbox" onChange={(e) => {
                                                    let objIndex = -1;
                                                    for (let i = 0; i < grid.length; i++) {
                                                        if (grid[i]['cn'] === x.cn) {
                                                            objIndex = i;
                                                            break;
                                                        }
                                                    }
                                                    updateGrid(objIndex, 'selected', e.target.checked)
                                                }} />
                                                    </td>
                                                    <td style={{ minWidth: 200 }}>
                                                        <button type="button" className="btn btn-sm btn-primary" onClick={async (e) => { await onGenerateLabels(x) }}>Generate Address Label</button>
                                                    </td>
                                                    <td>
                                                        {
                                                            !x.editMode && !x.addressLabelEdited &&
                                                            <button type="button" className="btn btn-sm btn-primary" onClick={e => {
                                                        let objIndex = -1;
                                                        for (let i = 0; i < grid.length; i++) {
                                                            if (grid[i]['cn'] === x.cn) {
                                                                objIndex = i;
                                                                break;
                                                            }
                                                        }
                                                        dispatch(updateGridObject({ index: objIndex, data: { ...x, editMode: true, addressLabelEdited: true } }))
                                                            }}>Edit</button>
                                                        }
                                                    </td>
                                                    <td>{x.cn}</td>
                                                    <td>
                                                        {x.consignee}
                                                    </td>
                                                    <td>
                                                        {x.pieces}
                                                    </td>
                                                    <td>
                                                        {x.weight}
                                                    </td>
                                                    <td>
                                                        {x.refNo}
                                                    </td>
                                                    <td>{x.bookingDate}</td>
                                                    <td>
                                                        {x.serviceType}
                                                    </td>
                                                    <td>
                                                        {x.codAmount}
                                                    </td>
                                            <td style={{ minWidth: 300 }}>
                                                <SeeMoreModal detail={x.productDetails} maxLength={120} />
                                                    </td>
                                            <td style={{ minWidth: 300 }}>
                                                <SeeMoreModal detail={x.remarks} maxLength={120} />
                                                    </td>
                                                    {
                                                        accountNo == "281588" && 
                                                        <>
                                                            <td>
                                                                {x.timeSlot}
                                                            </td>
                                                            <td>{x.deliveryDate}</td>
                                                            <td>
                                                                {x.deliveryType}
                                                            </td>
                                                        </>
                                                    }
                                                </tr>
                                                {
                                                    (x.editMode && x.addressLabelEdited) &&
                                                    <tr>
                                                        <td colSpan={14}>
                                                            <div className="row mt-3 mb-3">
                                                                <div className="col-2">
                                                                    <label>Consignee</label>
                                                                    <input type="text" className="form-control" defaultValue={x.consignee} maxLength={50} onInput={processStrWithSpace} onBlur={(e) => updateGrid(index, 'consignee', e.target.value)} />
                                                                </div>
                                                                <div className="col-2">
                                                                    <label>Pieces</label>
                                                                    <input type="text" className="form-control" defaultValue={x.pieces} maxLength={2} onInput={processInt} onBlur={(e) => updateGrid(index, 'pieces', e.target.value)} />
                                                                </div>
                                                                <div className="col-2">
                                                                    <label>Weight</label>
                                                                    <input type="text" className="form-control" defaultValue={x.weight} maxLength={4} onInput={processNum} onBlur={(e) => updateGrid(index, 'weight', e.target.value)} />
                                                                </div>
                                                                <div className="col-2">
                                                                    <label>Ref No</label>
                                                                    <input type="text" className="form-control" defaultValue={x.refNo} maxLength={20} onInput={processStr} onBlur={(e) => updateGrid(index, 'refNo', e.target.value)} />
                                                                </div>
                                                                <div className="col-2">
                                                                    <label>Service Type</label>
                                                                    <select className="form-select" defaultValue={x.serviceType} style={{ height: 40 }} onChange={(e) => updateGrid(index, 'serviceType', e.target.value)}>
                                                                        {services.map((x, index) => <option key={index} value={x}>{x}</option>)}
                                                                    </select>
                                                                </div>
                                                                <div className="col-2">
                                                                    <label>Cod Amount</label>
                                                            <input type="text" className="form-control" defaultValue={x.codAmount} maxLength={7} onInput={processNum} onBlur={(e) => updateGrid(index, 'codAmount', Math.round(e.target.value))} />
                                                                </div>
                                                                <div className="col-2">
                                                                    <label>Product Details</label>
                                                                    <textarea className="form-control" defaultValue={x.productDetails} maxLength={600} onInput={processStrWithSpace} onBlur={(e) => updateGrid(index, 'productDetails', e.target.value)} ></textarea>
                                                                </div>
                                                                <div className="col-2">
                                                                    <label>Remarks</label>
                                                                    <textarea className="form-control" defaultValue={x.remarks} maxLength={240} onInput={processStrWithSpace} onBlur={(e) => updateGrid(index, 'remarks', e.target.value)} ></textarea>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                }
                                            </Fragment>
                                        )
                                    }
                        />
                    }           
                    </div>
                </div>
            }
        </div>
    </section>
}

export default AddressLabel;